function getColor() {
  let r = Math.floor(Math.random() * 255).toString(16);
  if (r.length === 1) r = 0 + r;
  let g = Math.floor(Math.random() * 255).toString(16);
  if (g.length === 1) g = 0 + g;
  let b = Math.floor(Math.random() * 255).toString(16);
  if (b.length === 1) b = 0 + b;
  let color = `#${r.toString(16)}${g.toString(16)}${b.toString(16)}`;
  return color;
}
module.exports = {
  getColor
};



// WEBPACK FOOTER //
// ./src/service/randomColor.js